import { render, staticRenderFns } from "./forumDetail.vue?vue&type=template&id=bb71d90c&scoped=true&"
import script from "./forumDetail.vue?vue&type=script&lang=js&"
export * from "./forumDetail.vue?vue&type=script&lang=js&"
import style0 from "./forumDetail.vue?vue&type=style&index=0&id=bb71d90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb71d90c",
  null
  
)

export default component.exports